// extracted by mini-css-extract-plugin
export default {"root":"root--dfc0a63","ingredient":"ingredient--05dfd27","icons":"icons--fd3fa79","icon":"icon--6e6b71a"};